import React from "react"
import styles from "./styles.scss"
import { Button } from "components/Button"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from "react-router-dom"

class InfoBox extends React.Component {
  render() {
    const { title, body, buttonText, image, path } = this.props
    return (
      <div className={styles.container}>
        <div
          style={{ backgroundImage: `url("${image}")` }}
          className={styles.imageContainer}
        />
        <h2>{title}</h2>
        <p>{body}</p>
        {buttonText && (
          <Link to={path}>
          <Button type="submit">
            <p>{buttonText}</p> <FontAwesomeIcon icon="arrow-right" />
          </Button>
          </Link>
        )}
      </div>
    )
  }
}

export default InfoBox



// WEBPACK FOOTER //
// src/pages/LandingPage/components/InfoContainer/InfoBox/index.jsx